import { Observable } from 'rxjs';
export interface ComponentCanDeactivate {
  canDeactivate: boolean | Observable<boolean>;
}

export function CanDeactivateComponentGuard(component: ComponentCanDeactivate): boolean | Observable<boolean> {
  return component.canDeactivate;

}
